import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DatePipe } from '@angular/common';

import { Global } from '../../../../app.global';
import { BacklogReportsTextCopy } from '../../helper/textcopy/backlog-reports.text';

import { Constants } from '../../helper/constants';
import { ReportsService } from '../../services/reports.service';
import * as moment from 'moment';
// import * as jspdf from 'jspdf';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'backlog-reports',
  templateUrl: './backlog-reports.component.html',
  styleUrls: ['./backlog-reports.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BacklogReportsComponent implements OnInit {
  constants = Constants;
  reportsCopy = BacklogReportsTextCopy;
  loadingState = false;
  dateRangeText = '';
  datePipeEn: DatePipe = new DatePipe('en-UK');

  selectedFilter = 'month';
  fromDate: Date = new Date();
  toDate: Date = new Date();
  currentDate = new Date();
  showCustomReportsDateRange = false;
  backlogReport = {
    informalChallengeAverageWorkingDays: { value: 0 },
    informalChallengeAverageDays: { value: 0 },
    informalChallengeChange: 0,
    representationAverageWorkingDays: { value: 0 },
    representationAverageDays: { value: 0 },
    representationChange: 0,
    otherAverageWorkingDays: { value: 0 },
    otherAverageDays: { value: 0 },
    backlogValue: { value: 0 },
    otherChange: 0,
  };

  constructor(
    public global: Global,
    private reportsService: ReportsService
  ) {}

  ngOnInit() {
    this.setBacklogReport();
    this.setReportDateRange();
  }

  onChangeFilter(filterName) {
    if (this.selectedFilter === filterName) {
      return;
    }
    this.selectedFilter = filterName;
    if (filterName !== 'custom') {
      this.updateReports(filterName);
    }
  }

  updateReports(filterName) {
    this.showCustomReportsDateRange = filterName === 'custom';
    this.setBacklogReport();
    this.setReportDateRange();
  }

  setBacklogReport() {
    this.loadingState = true;
    this.reportsService
      .getBacklogPerformance(this.selectedFilter, this.fromDate, this.toDate)
      .subscribe(
        (result) => {
          this.backlogReport = this.reportsService.getFormattedBacklogReport(result);
          this.loadingState = false;
        },
        (error) => {
          this.loadingState = false;
          console.log(error);
        }
      );
  }

  setReportDateRange() {
    this.dateRangeText = this.showCustomReportsDateRange
      ? `from ${this.datePipeEn.transform(this.fromDate, 'd MMMM y')}
        to ${this.datePipeEn.transform(this.toDate, 'd MMMM y')}`
      : `${this.selectedFilter} to ${this.datePipeEn.transform(this.currentDate, 'd MMMM y')}`;
  }

  downloadDocument(format) {
    if (format === 'excel') {
      const extraField =
        '"informal-challenge stage",' +
        '"",' +
        '"",' +
        '"representations stage",' +
        '"",' +
        '"",' +
        '"other stages",' +
        '"",' +
        '"",' +
        '"value"' +
        '\r\n';

      this.reportsService.exportExcelDocument(
        this.reportsService.exportBacklogObject(this.backlogReport),
        this.getBacklogReportExportFields(),
        this.dateRangeText,
        extraField
      );
    } else {
      const reportsTable = document.getElementById('reports-backlog-table');
      const reportsTableClass = reportsTable.getAttribute('class');
      this.loadingState = true;
      reportsTable.classList.add('export-design');

      html2canvas(reportsTable, {
        scale: 3, // Increase the scale for better resolution
      }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jspdf('landscape', 'pt', 'a4');
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, undefined, 'FAST'); // Set quality to 'FAST' for lower compression
        reportsTable.className = reportsTableClass;
        this.loadingState = false;
        pdf.save('reports.pdf');
      });
    }
  }

  getBacklogReportExportFields() {
    return [
      'wkg days',
      'cal days',
      'change',
      'rep wkg days',
      'rep cal days',
      'rep change',
      'other wkg days',
      'other cal days',
      'other change',
      ' ',
    ];
  }
}
